export default "__VITE_ASSET__K7l0rRyw__"